import React, {Component} from 'react'
import ReactHtmlParser from 'react-html-parser'
import {transformArticleBodyContent} from '../../utils/html'

class ArticleBody extends Component {
  render () {
    const {article} = this.props
    return (
      <div className='ArticleBody'>
        {ReactHtmlParser(article.body, {
          decodeEntities: true,
          transform: transformArticleBodyContent
        })}
      </div>
    )
  }
}

ArticleBody.defaultProps = {}

export default ArticleBody



// WEBPACK FOOTER //
// ./client/components/ArticleBody/ArticleBody.js